var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_18573_5952)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_18573_5952)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.3001,
    cy: 14.0003,
    r: 12.18,
    fill: "url(#paint1_linear_18573_5952)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3123 6.99679C14.1523 7.01219 14.9923 7.00519 15.8323 7.05279C16.3293 7.08079 16.4903 6.70839 16.6373 6.40459C16.9649 5.72839 17.4773 5.54639 18.1773 5.61219C19.0593 5.69479 19.9441 5.73819 20.8275 5.79979C21.7809 5.86699 22.1715 6.47179 21.8397 7.38459C21.6171 7.99639 21.3987 8.61099 21.1397 9.20459C20.9675 9.59099 21.0249 9.90459 21.2335 10.2504C21.9713 11.4838 22.6769 12.7382 23.4189 13.9702C23.7927 14.5918 24.0461 15.2134 23.8109 15.9484C23.7595 16.1274 23.7234 16.3106 23.7031 16.4958C23.3783 18.7862 22.8771 19.1558 20.8415 19.3714C20.3081 19.4274 20.0365 19.7788 19.7033 20.1526C18.4209 21.5904 16.7255 22.345 14.9111 22.8658C14.4225 23.0058 13.9311 23.115 13.4313 23.2382C12.7061 23.4006 11.9739 23.5378 11.2585 23.731C9.83474 24.116 9.22014 23.3908 8.89674 22.324C8.43054 20.8316 7.93634 19.335 7.71234 17.7852C7.47014 16.1346 7.29234 14.4644 8.00354 12.8614C8.04033 12.78 8.06028 12.6921 8.0622 12.6028C8.06413 12.5136 8.04798 12.4248 8.01474 12.342C7.89714 12.0144 7.83134 11.6756 7.71234 11.3494C7.17474 9.96339 7.41834 9.30259 8.58594 8.34639C8.62094 8.31699 8.67834 8.31279 8.70494 8.27919C9.71154 7.00519 11.0947 6.90719 12.5563 7.02759C12.8087 7.03386 13.0613 7.02357 13.3123 6.99679ZM12.7383 8.57879C11.9067 8.56619 11.0933 8.29879 10.2729 8.86859C9.04934 9.70859 8.77914 10.676 9.54494 11.9402C9.55614 11.9598 9.55894 11.985 9.56874 12.006C9.82074 12.5058 9.81374 12.9636 9.45254 13.434C9.21314 13.7476 9.13334 14.1466 9.08854 14.554C8.79594 17.1902 9.73254 19.594 10.4507 22.0482C10.5151 22.2694 10.6383 22.3562 10.8623 22.2848C12.0285 21.911 13.2633 21.8018 14.4169 21.3776C15.8379 21.0976 17.0573 20.3976 18.2053 19.5576C18.4944 19.3552 18.7162 19.0709 18.8423 18.7414C18.9823 18.3368 19.2623 18.1548 19.6543 18.0862C19.9735 18.0302 20.2913 17.9602 20.6105 17.8986C21.9209 17.6424 21.8901 17.6354 22.2163 16.3124C22.3941 15.59 22.3269 14.9852 21.8943 14.3524C21.3077 13.4998 20.8345 12.5688 20.2717 11.6924C19.6207 10.683 19.1951 9.70019 19.7705 8.46399C20.3207 7.28099 20.2493 7.28659 18.9459 7.17459C18.2781 7.11719 17.7909 7.20679 17.4815 7.87459C17.2155 8.44299 16.7045 8.60259 16.0815 8.58719C14.9713 8.55639 13.8541 8.57739 12.7369 8.57879H12.7383Z",
    fill: "#FDFDFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18573_5952",
    x: 0.440117,
    y: 0.140312,
    width: 27.7204,
    height: 27.7194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.84,
    result: "effect1_foregroundBlur_18573_5952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18573_5952",
    x1: 1,
    y1: 12.18,
    x2: 29,
    y2: 12.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B179FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4AB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18573_5952",
    x1: 26.4801,
    y1: 14.0003,
    x2: 2.80524,
    y2: 14.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36277A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39297E",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelos);
export default __webpack_public_path__ + "static/media/telos.c6d40d1cad578f1b50fea0490fccac40.svg";
export { ForwardRef as ReactComponent };